import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const RevisionsRequested = new StatusEnumItem({
  id: 'a7b9c363-e121-4751-837c-7206ddcf5979',
  priority: 0,
  name: 'Revisions Requested',
  description: 'A router has determined the Submittal requires revisions',
})

const REReview = new StatusEnumItem({
  id: 'c6aabe38-b180-441d-9c5a-8cc2858fa336',
  priority: 3,
  name: 'RE Review',
  description: 'The Resident Engineer gives their final disposition',
})

const GroupReview = new StatusEnumItem({
  id: '1c1a7434-ea18-4850-8b19-273f662db406',
  priority: 2,
  name: 'Group Review',
  description:
    'Routing Groups are checked off by Approvers before the Submittal may advance to RE Review',
})

const RouterReview = new StatusEnumItem({
  id: 'a33becbc-738d-4be7-b839-bd98030ad062',
  priority: 1,
  name: 'Router Review',
  description: `Routers review the current state of the Submittal to request revisions, route to ${GroupReview.name}, route to ${REReview.name}, or submit the Disposition`,
})

const Closed = new StatusEnumItem({
  id: '58f023e5-2ac0-4496-a9c2-f49bbd030af0',
  priority: 4,
  name: 'Closed',
  description:
    'The Submittal has completely gone through the Submittal Tracker workflow. Its associated SharePoint folder is locked from editing',
})

const Unlocked = new StatusEnumItem({
  id: '64e9c579-9a6e-42b7-a625-e5dcadd6734e',
  priority: 5,
  name: 'Unlocked',
  description:
    'The Submittal has completely gone through the Submittal Tracker workflow, but its associated SharePoint folder is unlocked for editing',
})

export type CASStatusItem =
  | typeof RevisionsRequested
  | typeof REReview
  | typeof GroupReview
  | typeof RouterReview
  | typeof Closed
  | typeof Unlocked

class CASStatusEnum extends StatusEnum<
  'CASStatus',
  CASStatusItem,
  CASStatusItem['name'],
  CASStatusItem['id'],
  CASStatusItem['priority']
> {
  typename = 'CASStatus' as const
  readonly RevisionsRequested = RevisionsRequested
  readonly REReview = REReview
  readonly GroupReview = GroupReview
  readonly RouterReview = RouterReview
  readonly Closed = Closed
  readonly Unlocked = Unlocked
  get values() {
    return [
      this.RevisionsRequested,
      this.REReview,
      this.GroupReview,
      this.RouterReview,
      this.Closed,
      this.Unlocked,
    ]
  }
}

export const CASStatus = new CASStatusEnum()
